import { Card, Col, Container, Row } from "react-bootstrap";
import { useLoaderData, useNavigate } from "react-router-dom";
import { Order } from "./Data/ApiTypes";
import { PageTitle       } from "./Controls/PageTitle";
import { showMoney } from "./Data/Money";
import { facilityImg     } from "./Data/Common";
import { showOrderType   } from "./Data/Finance";
import { showInstantDate } from "./Data/Date";
import { OrderPaidBadge  } from "./Controls/OrderPaidBadge";
import { OutstandingBalanceBanner } from "./Controls/OutstandingBalanceBanner";

export function UserOrdersPage() {
    const nav = useNavigate();
    const orders = useLoaderData() as Order[];
    return <Container fluid>
        <Row>
            <Col>
                <PageTitle>
                    Orders
                </PageTitle>
                <OutstandingBalanceBanner perFacility />
                {orders.length === 0 && <>
                    You haven't placed any orders
                </>}
                {orders.map( order => {
                    const facility = order.facility;
                    return <Card key={order.orderId} className="my-3" style={{ cursor: "pointer" }}
                                 onClick={() => nav(`/user/order/${order.orderId}`)}>
                        <Card.Header className="text-start fw-bold d-flex gap-2 align-items-center">
                            <OrderPaidBadge balance={order.balance.balance} /> #{order.orderId} {showOrderType( order.type )}
                        </Card.Header>
                        <Card.Body className="purchase-layout gap-2">
                            <div className="grid-area-a">
                                <img className="facility-result-pic"
                                    src={facilityImg( facility.listImageId )}
                                    style={{ aspectRatio: "1 / 1", objectFit: "cover" }} />
                            </div>
                            <div className="grid-area-b">
                                <div className="fw-bold">
                                    {facility.name}
                                </div>
                                <div>
                                    {order.summary}
                                </div>
                            </div>
                            <div className="grid-area-c" />
                        </Card.Body>
                        <Card.Footer className="d-flex align-items-center justify-content-between gap-2 flex-wrap py-1 bg-white">
                            <span className="text-muted small">
                                {showInstantDate( order.createdWhen, facility.timeZone )}
                            </span>
                            <span className="fw-bold">
                                {showMoney( order.price )}
                            </span>
                        </Card.Footer>
                    </Card>;
                } )}
            </Col>
        </Row>
    </Container>;
}